<template>

  <div class="reporting-table-reports" >

    <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
      <div class="clearfix row py-2 mb-2 no-margin">
        <div class="col-md-2 pr-0 cursor-pointer text-left pl-0">

          <b-form-group label="Select Month and Year">
            <div class="d-flex gap-2">
                <b-form-select @input="getCustomList" v-model="selected_month" :options="month_options" class="mr-2" name="selected_month"></b-form-select>
                <b-form-select @input="getCustomList" v-model="selected_year" :options="year_options" name="selected_year"></b-form-select>
            </div>
            </b-form-group>


        </div>
        <div class="col-md-10 no-margin p-0">
          <div class="row d-flex justify-content-end no-margin">
            <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(0)">Preview Report</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="resetView()">Reset Selection</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(1)">Download Report (Excel)</b-button>
          </div>
        </div>
      </div>
      <div v-if="this.is_grid_diplayable" >
        <common-list-leave-report ref="leaveReport" :checkbox="checkbox" :leave_type_options="this.leave_type_options" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list-leave-report> 

      </div>
      <div v-else class="monthly-report-wrap">

        <table v-if="flag == 1" class="table dataTable reporting-preview-report-table">
            <thead class="table-head">
                <tr>
                <th class="position-sticky">SL</th>
                <th class="position-sticky" v-for="col in previewColumns" :key="col.key">{{ col.title }}</th>
                <th>Working Day</th>
                <th>Present</th>
                <th>Late</th>
                <th>Early Out</th>
                <th>Incomplete Days</th>
                <th>Leave</th>
                <th>Absent</th>
                <th>Holiday</th>
                <th>Weekend</th>
                <th>Expected Duty(H)</th>
                <th>Actual Duty(H)</th>
                <th>Average Duty(H)</th>
                <th>Late(H)</th>
                <th>Early Out(H)</th>
                <th>Incomplete Hours</th>
                <th>Extra Duty(H)</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(data, index) in preview_data" :key="data.employee_id">
                <td class="bg-white position-sticky">{{ index + 1 }}</td>
                <td class="bg-white position-sticky" v-for="col in previewColumns" :key="col.key">{{ data[col.key] }}</td>
                <td>{{ data.working_day }}</td>
                <td>{{ data.attendances_count }}</td>
                <td>{{ data.late_count }}</td>
                <td>{{ data.early_out }}</td>
                <td>{{ data.incomplete_days }}</td>
                <td>{{ data.leave}}</td> 
                <td>{{ data.absent }}</td>
                <td>{{ data.holiday}}</td>
                <td>{{ data.weekend}}</td> 
                <td>{{ data.expected_duty }}</td>
                <td>{{ data.actual_duty }}</td>
                <td>{{ data.average_duty }}</td>
                <td>{{ data.late }}</td>
                <td>{{ data.early }}</td>
                <td>{{ data.incomplete_hours }}</td>
                <td>{{ data.extra_duty }}</td>
                </tr>
            </tbody>
        </table>

        <table v-else class="table dataTable reporting-preview-report-table">
            <thead class="table-head">
                <tr>
                <th class="position-sticky">SL</th>
                <th class="position-sticky" v-for="col in previewColumns" :key="col.key">{{ col.title }}</th>
                <th v-for="date in dates" :key="date">{{ formatHeader(date) }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(employee, index) in preview_data" :key="employee.employee_id">
                <td class="bg-white position-sticky">{{ index + 1 }}</td>
                <td class="bg-white position-sticky" v-for="col in previewColumns" :key="col.key">{{ employee[col.key] }}</td>
                <td v-if="flag == 2" v-for="entry in employee.daily_entries"> <span :class="'text-'+entry.variant">{{entry.text}}</span>  </td>
                <td v-if="flag == 3" v-for="entry in employee.daily_entries"> <span :class="'text-'+entry.variant">{{entry.inout}}</span>  </td>
                <td v-if="flag == 4" v-for="entry in employee.daily_entries"> <span :class="'text-'+entry.variant">{{entry.worktime}}</span>  </td>
                </tr>
            </tbody>
        </table>

      </div>

    </b-overlay>
  </div>
</template>


<script>

import moment from 'moment'
export default{

    props:['flag'],

  data(){
    const now = new Date();
    let sortOrders = {};
    let columns = [
      { label: "SL", name: "employee_id" },
      { label: "Employee Code", name: "employee_code" },
      { label: "Name", name: "name" },
      { label: "Email", name: "email" },
      { label: "Phone", name: "phone" },
      { label: "Department", name: "department" },
      { label: "Position", name: "jobposition" },
      { label: "Branch", name: "branch" },
      { label: "Manager", name: "manager" },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    const currentYear = new Date().getFullYear();
    const yearRange = 150;

    return {
        dates:[],
        selected_year: currentYear,
        selected_month: ('0' + (new Date().getMonth() + 1)).slice(-2), // e.g., "06"

        year_options: Array.from({ length: yearRange }, (_, i) => currentYear - i),
        month_options: Array.from({ length: 12 }, (_, i) => {
            const value = ('0' + (i + 1)).slice(-2);
            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];
            return {
                value: value,
                text: monthNames[i]
            };
        }),
      pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
      selected_date:'',
      date_max:'',
      selected: [],
      columns: columns,
      sortKey: 'name',
      sortOrders: sortOrders,
      checkbox:1,
      is_action:1, /* As this list have actions then is_action will be 1. Otherwise, it will be 0 */
      list_key:0, /* Component Key */
      custom_list:[],  /* Data List */
      default_column:['name','phone','email','jobposition','department','branch','leave_policy','leave_type'], /* Default Column List */
      appended_column:[
      ],
      leave_type_options:[],                /* Appended Column List  and there title and type */
      primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
      company_options:[],         /* Company Filterable options */

      tmp_custom_list:[],

      selected_fiscal_year: '',
      current_fiscal_year: now.getFullYear(),
      employee_ids: [],
      // new
      preview_data: '',
      is_preview: 0,
      is_grid_diplayable: 1,

      showoverlay : false,
      cached_enabled_fields: [],
    }
  },
  methods:{
    resetView: function()
    {
      this.is_grid_diplayable = 1;
      this.preview_data = '';
      this.selected = [];
      this.employee_ids = [];
      this.list_key +=1;
      this.cached_enabled_fields = [];

    },

    formatHeader(dateStr) {
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return new Date(dateStr).toLocaleDateString('en-US', options); 
    },
    listReturn:function(data)
    {
        this.selected = data;
        this.employee_ids = this.selected.selected;

    },

    getCustomList: function()
    { 
        
        if(!this.checkNet()) return false;
        let currentObj = this; 
        
        this.resetView() // 14 july 2025 asfaq
        axios.get(this.$api_url+'/leaveattendancereport/getcustomlist?flg=1&month='+this.selected_month+'&year='+this.selected_year , {

        }).then(function(response){

            /* Assingning the list */ 
            this.tmp_custom_list = response.data.employee_data;
            this.leave_type_options = response.data.leave_type_options;
            /* Assingning the Options */ 
            this.company_options = response.data.options;

            /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
            if(this.tmp_custom_list.length > 0 )
            {
                this.tmp_custom_list.forEach(element => {

                        if(element.leave_type.length>0)
                        {
                            let types = [];
                            let type_ids = [];
                            element.leave_type.forEach(newelement => {

                                types.push(newelement.value);
                                type_ids.push(newelement.id);
                                
                                });

                                element.leave_types = types.join(" , ");
                                element.leave_type_ids = type_ids;
                        }
                        else
                        {
                            element.leave_types = 'Not Available';
                            element.leave_type_ids = [];

                        }
                      });
                
            }
            
            this.custom_list = this.tmp_custom_list;
            

            this.list_key = this.list_key + 1;
        }.bind(this)).catch(function (error){currentObj.serverError(error);});

    }, 
    previewOrDownload: function(flg)
    {
      if(!this.checkNet()) return false;

      if (this.employee_ids.length == 0){
        this.$bvToast.toast("Please select employee(s) to generate report", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
        return;
      }

      let currentObj = this;
      if(flg == 0)
      {
        this.$bvToast.toast('We are generating the report, this may take a while, please hold tight.', {
          title: `Info`,
          variant: 'info',
          solid: true
        });
      }
      else if(flg == 1)
      {
        this.$bvToast.toast('We are downloading the report, this may take a while, please hold tight.', {
          title: `Info`,
          variant: 'info',
          solid: true
        });
      }

         let config = {};

        if(flg == 1)
        {
        config = {
            responseType: 'blob' 
        }
        }

      let fileName = 'Monthly Report Summary';

        switch (flg) {
          case 2: fileName = 'Monthly Attendance Report'; break;
          case 3: fileName = 'Monthly In Out Report'; break;
          case 4: fileName = 'Monthly Working Hour Report'; break;
        }
      // 1 = monthly attendance summary
      // 2 = monthly attendance report
      // 3 = monthly in out report
      // 4 = working hour report

      this.showoverlay = true;

      let enabledFields = [];
      if (this.$refs.leaveReport) {
          const defaultFields = this.$refs.leaveReport.default_column || [];
          const appendedFields = (this.$refs.leaveReport.appended_column || []).map(col => col.value || col);
          const selectedFields = this.$refs.leaveReport.column_selected || [];
          enabledFields = [...defaultFields, ...appendedFields, ...selectedFields];
          this.cached_enabled_fields = enabledFields;
      } else {
          enabledFields = this.cached_enabled_fields || [];
      }
      enabledFields = enabledFields.filter(field => field !== 'leave_type');

      let formData = new FormData()
      formData.append('employee_ids', JSON.stringify(this.employee_ids))
      formData.append('date', this.selected_year+'-'+this.selected_month)
      formData.append('is_export', flg)
      formData.append('flag', this.flag)
      formData.append('enabled_fields', JSON.stringify(enabledFields))
      axios.post(this.$api_url+'/la/report/monthly', formData, config).then(response=> 
        {
          this.showoverlay = false;

          if(flg == 0)
          {
            if(this.flag == 1)
            {
                this.preview_data = response.data
            }
            else
            {
                this.preview_data = response.data.attendances;
                this.dates = response.data.dates;
            }
            console.log(response.data);
            this.is_preview = 1;
            this.is_grid_diplayable = 0;
          }
          else if(flg == 1)
          {
            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            const downloadLink = document.createElement('a');
            downloadLink.href = blobUrl;
            downloadLink.setAttribute('download', fileName + '.xlsx');
            document.body.appendChild(downloadLink);
            downloadLink.click();

            // Cleanup
            setTimeout(() => {
                window.URL.revokeObjectURL(blobUrl);
                document.body.removeChild(downloadLink);
            }, 100);
          }
        }).catch(function (error){ currentObj.serverError(error);});

    },
    download_file(fileURL)
    {
      if(!this.checkNet()) return false;

      var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
      if (!window.ActiveXObject) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
        save.download = fileName || filename;
        if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
          document.location = save.href;
        }else{
          var evt = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
          });
          save.dispatchEvent(evt);
          (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
      }
      else if ( !! window.ActiveXObject && document.execCommand)     {
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL)
        _window.close();
      }
    },
  },
  computed:
      {
        previewColumns() {
          const titleMap = {
            'employee_code': 'Employee Code',
            'name': 'Employee Name',
            'phone': 'Mobile Number',
            'email': 'Email',
            'jobposition': 'Designation',
            'designation': 'Designation',
            'department': 'Department',
            'branch': 'Branch',
            'leave_policy': 'Leave Policy',
            'leave_type': 'Leave Type',
          };

          const fields = this.cached_enabled_fields && this.cached_enabled_fields.length > 0
            ? this.cached_enabled_fields
            : ['employee_code', 'name', 'jobposition', 'department'];

          return fields.map(field => {
            let key = field;
            if (field === 'designation') key = 'jobposition';
            return {
              key: key,
              title: titleMap[field] || field.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
            };
          });
        },
        filteredData()
        {
          let filtered_list = this.custom_list;
          if (this.search)
          {
            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

            if(filtered_list.length == 0)
              this.blankmsg = "Nothing found.";
          }

          this.people = filtered_list.length;

          return filtered_list;
        },
        paginatedData()
        {
          return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        selectAll: {
          get: function () {
            // return this.employees ? this.selected.length == this.employees.length : false;
            return this.filteredData ? this.employee_ids.length == this.filteredData.length : false;
          },
          set: function (value) {
            let selected = [];
            if (value) {
              this.filteredData.forEach(function (user) {
                selected.push(user.employee_id);
              });
            }
            this.employee_ids = selected;
          }
        },
      },
  created: function(){
    this.getCustomList();
  }
}
</script>

<style scoped>
.r-custom tr td
{
  width: 14.28571%;
}

table {
  table-layout: auto;
  width: auto;
  min-width: 100%;
}

td, th {
  white-space: nowrap;
  padding: 4px 8px; /* Adjust padding as needed */
}


</style>
